<template>
  <modal
    :adaptive="false"
    :click-to-close="false"
    :shift-y="0.3"
    name="processing"
    style="z-index: 1 !important;"
    @before-open="ready"
  >
    <div class="container p-10 mx-auto">
      <div class="px-5 py-10 bg-yellow-400 border-4 border-gray-900 rounded-lg shadow-lg">
        <!-- eslint-disable -->
        <p
          :class="$style.p"
          class="text-lg sm:text-3xl font-bold leading-normal sm:leading-loose tracking-tight sm:tracking-widest text-center text-white"
          v-html="message"
        ></p>

        <JGProgressbar v-if="progressbar" :delay="2000" class="mt-4" />
      </div>
    </div>
  </modal>
</template>

<script>
import * as _ from 'lodash'
import JGProgressbar from '@src/games/jongrogu/components/jg-progressbar.vue'

export default {
  name: 'JGProcessingModal',
  components: { JGProgressbar },
  data() {
    return {
      message: null,
      progressbar: false,
    }
  },
  methods: {
    ready(event) {
      this.message = _.get(event, 'params.message', '잠시만 기다려 주세요...')
      this.progressbar = _.get(event, 'params.progressbar', false)
    },
  },
}
</script>

<style lang="scss" module>
.p {
  text-shadow: 1px 1px 5px #333;
}
</style>
